import api from './api';

const unwrap = <T>(response: any): T => response.data?.data ?? response.data;

export interface Subject {
  id: number;
  name: string;
  enabled: boolean;
  created_at: string;
  updated_at: string;
  created_by?: number;
  updated_by?: number;
}

export interface CreateSubjectData {
  name: string;
  enabled?: boolean;
}

export const subjectService = {
  async getAll(): Promise<Subject[]> {
    const response = await api.get('/subjects');
    return unwrap<Subject[]>(response);
  },

  async getById(id: number): Promise<Subject> {
    const response = await api.get(`/subjects/${id}`);
    return unwrap<Subject>(response);
  },

  async create(data: CreateSubjectData): Promise<Subject> {
    const response = await api.post('/subjects', data);
    return unwrap<Subject>(response);
  },

  async update(id: number, data: Partial<CreateSubjectData>): Promise<Subject> {
    const response = await api.put(`/subjects/${id}`, data);
    return unwrap<Subject>(response);
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/subjects/${id}`);
  },
};

